module.exports = __webpack_public_path__ + "8e0e90324cb6071eadb3ea7355dbf91e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/star.png
// module id = 3706
// module chunks = 0